import ClassOperation from '@/api/class-operation'
import SubProgram from '@/api/sub-program'
import ClassAttendanceCheckList from '@/api/report-class-attendance-check-list'
import Term from '@/api/term-semester'
import Year from '@/api/academic-year'
import Level from '@/api/level'
import MainProgram from '@/api/main-program'
import TeacherProfile from '@/api/teacher-profile'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
    ...baseState,
    selected_month: moment().format('MM-YYYY')
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_SELECTED_MONTH(state, month) {
        state.selected_month = month
    }
}

export const actions = {
    getSubProgram(context, attributes = {}) {
        return SubProgram.get({
            params: Object.assign(
                {
                    fields: {
                        academic_program_subs: 'acps_id,acps_name_foreign'
                    },
                    page: -1
                },
                attributes
            ),
            headers: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })
    },
    getYear(context, attributes = {}) {
        return Year.get({
            params: Object.assign(
                {
                    fields: {
                        academic_years: 'ac_year_id,ac_year,ac_status_id'
                    },
                    page: -1
                },
                attributes
            ),
            headers: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })
    },
    getLevel(context, attributes = {}) {
        return Level.get({
            params: Object.assign(
                {
                    fields: {
                        academic_program_levels: 'level_id,level_name_foreign'
                    },
                    page: -1
                },
                attributes
            ),
            headers: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })
    },

    // preview class attendance as PDF file
    classAttendance(context, attributes = {}) {
        return ClassAttendanceCheckList.classAttendance({
            params: Object.assign(
                {
                    month: context.state.selected_month
                },
                attributes
            )
        })
    },
    getMainProgram(context, attributes = {}) {
        return MainProgram.get({
            params: {
                fields: {
                    academic_program_mains: 'acp_id,acp_name_foreign'
                },
                page: -1
            },
            headers: {
                'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
            }
        })
    },
    getTeacher(context, params) {
        {
            return ClassAttendanceCheckList.getTeacher(params);

        }
    },
    getStudyTimeOptions(context, data) {
        return ClassAttendanceCheckList.fetchStudyTime(data);
    },
    getClassByTeacher(context, params) {
        return ClassAttendanceCheckList.getClasslass(params)
    },
    getTerm(context, params) {
        return ClassAttendanceCheckList.getTerm(params)
    },

}
